module.exports = __webpack_public_path__ + "static/media/008-dribbble.9d26ad14.svg";